import { ChangeDetectionStrategy, Component, OnInit, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { FromDictionaryPipe, LanguageService } from '@teamfoster/sdk/dictionary-ngrx';
import { Observable } from 'rxjs';
import { DeleteCustomerAccessToken, getCustomer } from 'src/app/shop';

@Component({
    selector: 'app-account-layout',
    templateUrl: './account-layout.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class AccountLayoutComponent implements OnInit {
  private lang = inject(LanguageService);
  private store = inject(Store);
  private dict = new FromDictionaryPipe(this.lang);

  customer$ = this.store.selectSignal(getCustomer);
  navItems: { title: string; routerLink: string[]; icon: string }[] = [];

  constructor() {}

  ngOnInit(): void {
    this.navItems = [
      // {
      //   title: this.dict.transform(`account-menu-titel`),
      //   routerLink: ['/account'],
      //   icon: 'icon-layout',
      // },
      {
        title: this.dict.transform(`account-profiel-menu-titel`),
        routerLink: ['/account'],
        icon: 'icon-user',
      },
      {
        title: this.dict.transform(`account-orders-menu-titel`),
        routerLink: ['/account/orders'],
        icon: 'icon-truck',
      },
    ];
  }

  signOut() {
    this.store.dispatch(DeleteCustomerAccessToken());
  }
}
